import React from "react";
import { useField } from "formik";

const FormikSelect = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  const hasError = meta.touched && meta.error;
  return (
    <div className={`formik-field-container ${hasError ? "invalid" : ""}`}>
      {label && <label htmlFor={props.id || props.name}>{label}</label>}
      <select {...field} {...props} />
      <div className={`feedback ${hasError ? "error" : ""}`}>{hasError ? meta.error : "looks good"}</div>
    </div>
  );
};

export default FormikSelect;
